import { Component, Input } from '@angular/core';
import { BePontoEletronicoLog } from 'src/app/models/BePontoEletronicoLog';

interface DiaCalendario {
  data: Date;
  pertenceAoMes: boolean;
}

@Component({
  selector: 'app-ponto-eletronico-calendario',
  templateUrl: './ponto-eletronico-calendario.component.html',
  styleUrls: ['./ponto-eletronico-calendario.component.css']
})
export class PontoEletronicoCalendarioComponent {
  @Input() public logs: BePontoEletronicoLog[] = [];

  public readonly diasDaSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  public mesExibido: Date;

  public constructor() {
    const hoje = new Date();
    this.mesExibido = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
  }

  public get tituloMes(): string {
    const titulo = this.mesExibido.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
    return titulo.charAt(0).toUpperCase() + titulo.slice(1);
  }

  public get dias(): DiaCalendario[] {
    const inicioMes = new Date(this.mesExibido.getFullYear(), this.mesExibido.getMonth(), 1);
    const inicioCalendario = new Date(inicioMes.getFullYear(), inicioMes.getMonth(), 1 - inicioMes.getDay());

    return Array.from({ length: 42 }, (_, indice) => {
      const data = new Date(inicioCalendario.getFullYear(), inicioCalendario.getMonth(), inicioCalendario.getDate() + indice);
      return {
        data,
        pertenceAoMes: data.getMonth() === this.mesExibido.getMonth()
      };
    });
  }

  public mudarMes(deslocamento: number): void {
    this.mesExibido = new Date(this.mesExibido.getFullYear(), this.mesExibido.getMonth() + deslocamento, 1);
  }

  public logsDoDia(dia: DiaCalendario): BePontoEletronicoLog[] {
    return this.logs
      .filter(log => this.ehMesmoDia(this.obterDataLog(log), dia.data))
      .sort((logA, logB) => this.obterDataLog(logA)!.getTime() - this.obterDataLog(logB)!.getTime());
  }

  public obterHorario(log: BePontoEletronicoLog): string {
    const data = this.obterDataLog(log);
    return data
      ? `${String(data.getHours()).padStart(2, '0')}:${String(data.getMinutes()).padStart(2, '0')}:${String(data.getSeconds()).padStart(2, '0')}`
      : '';
  }

  public obterTextoTag(log: BePontoEletronicoLog): string {
    const descricao = this.obterDescricao(log);
    return descricao ? `${this.obterHorario(log)} - ${descricao}` : this.obterHorario(log);
  }

  public ehSimulacao(log: BePontoEletronicoLog): boolean {
    return log.dsMensagem?.startsWith('Simulação realizada') ?? false;
  }

  public ehHoje(dia: DiaCalendario): boolean {
    return this.ehMesmoDia(dia.data, new Date());
  }

  public readonly rastrearDia = (_: number, dia: DiaCalendario): string => this.chaveData(dia.data);

  public rastrearLog(_: number, log: BePontoEletronicoLog): number | string {
    return log.id ?? `${log.dtCriado}-${log.dsMensagem ?? ''}`;
  }

  private obterDataLog(log: BePontoEletronicoLog): Date | null {
    const data = new Date(log.dtCriado);
    return Number.isNaN(data.getTime()) ? null : data;
  }

  private obterDescricao(log: BePontoEletronicoLog): string | null {
    if (this.ehSimulacao(log)) {
      return 'Simulação';
    }

    const feriado = log.dsMensagem?.match(/^(?:Registro bloqueado|Feriado):\s*(.+?)\.\s*$/i);
    return feriado?.[1] ?? null;
  }

  private ehMesmoDia(dataA: Date | null, dataB: Date): boolean {
    return !!dataA && dataA.getFullYear() === dataB.getFullYear() &&
      dataA.getMonth() === dataB.getMonth() && dataA.getDate() === dataB.getDate();
  }

  private chaveData(data: Date): string {
    return `${data.getFullYear()}-${data.getMonth()}-${data.getDate()}`;
  }
}
